import { Formik } from 'formik';
import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { toast, Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { z } from 'zod';
import { toFormikValidationSchema } from 'zod-formik-adapter';
import { BASE_URL } from '../api';
import { user_email } from '../atoms/atoms';
import background from '../img/Background.png';
import logo from '../img/logo.png';

const UpdatePassword = () => {
	const [isFormSubmitted, setIsFormSubmitted] = useState(false);
	const [email, setEmail] = useAtom(user_email);
	const [newPassword, setNewPassword] = useState('');
	const [newPassword2, setNewPassword2] = useState('');
	const navigate = useNavigate();

	useEffect(() => {
		if (isFormSubmitted) {
			navigate('/login');
		}
	}, [isFormSubmitted]);

	const Schema = z.object({
		email: z.string().email(),
	});

	const userData = new FormData();
	userData.append('email', email);
	userData.append('new_password', newPassword);

	const handleUpdate = async () => {
		if (newPassword !== newPassword2) {
			return toast.error('Both passwords must match.');
		}

		const data = await fetch(`${BASE_URL}resetPassword`, {
			method: 'POST',
			headers: {
				'Accept-Language': 'en-US,en;q=0.8',
			},
			body: userData,
		})
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				if (data.message === 'Password updated successfully.') {
					toast.success('Password updated successfully.');
					setIsFormSubmitted(true);
				} else {
					toast.error('Error updating password.');
				}
			})
			.catch((err) => console.log(err));
		return data;
	};

	return (
		<>
			<Toaster />

			<div
				className="h-screen flex flex-col bg-gray-300 items-center justify-center bg-cover"
				style={{ backgroundImage: `url(${background})` }}
			>
				<div className="flex items-center">
					<div>
						<Formik<{}>
							validationSchema={toFormikValidationSchema(Schema)}
							initialValues={{
								newPassword: '',
								newPassword2: '',
							}}
							onSubmit={(values, { setSubmitting }) => {
								setSubmitting(true);
								handleUpdate();
								setSubmitting(false);
							}}
						>
							{({ handleChange, values, handleBlur, submitForm, handleSubmit, errors }) => (
								<form onSubmit={handleSubmit}>
									<div className="p-8 mx-auto flex flex-col bg-white justify-center border border-b-4 rounded-xl w-[540px] ">
										<img src={logo} width={200} alt="logo" className="mx-auto mb" />

										<div className="flex flex-col items-start mx-auto">
											<div className="flex flex-col">
												<label className="font-semibold mb-2">Nueva contraseña</label>

												<div className="pb-2">
													<input
														type="password"
														name="password1"
														className="outline-none focus:ring-1 bg-white flex-1 rounded px-6 py-2 border border-gray-300 w-72"
														placeholder="Nueva contraseña"
														onChange={(e) => setNewPassword(e.target.value)}
														value={newPassword}
													/>
												</div>
											</div>

											<div className="flex flex-col">
												<div className="pb-2">
													<input
														type="password"
														name="password2"
														className="outline-none focus:ring-1 bg-white flex-1 rounded px-6 py-2 border border-gray-300 w-72"
														placeholder="Repetir contraseña"
														onChange={(e) => setNewPassword2(e.target.value)}
														value={newPassword2}
													/>
												</div>
											</div>

											<button
												onClick={() => {
													handleUpdate();
												}}
												style={{
													backgroundColor: '#ce3d5a',
												}}
												className="text-white shadow w-72 rounded p-2 font-semibold"
											>
												Actualizar contraseña
											</button>
										</div>
									</div>
								</form>
							)}
						</Formik>{' '}
					</div>
				</div>
			</div>
		</>
	);
};

export default UpdatePassword;
